// Verbatim statutory note requested for the printed-document footer
// (PO / Invoice / Sales Order) — must accompany consignment + invoicing
// instructions so the vendor's payment isn't delayed for missing details.
export const StatutoryFooterNote = () => (
    <div className="statutory-footer-note">
        Note: Tax Invoice along with valid E-waybill should accompany the consignment. Tax invoice should be
        sent to the billing address wherein following details are essential to process your invoice for
        payment purpose. i) ACC No. ii) Your GSTIN No. iii) Supplier Code iv) Purchase Order No. v) Item No.
        vi) Description vii) Quantity vii) HSN / SAC of the supply. TDS if applicable will be deducted as per
        the norms. If PAN not furnished, TDS if applicable will be deducted @20%.
    </div>
);
